const Spinner = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.888 9.56601C43.4611 7.4779 36.538 7.478 30.1112 9.56629C23.6843 11.6546 18.0835 15.7238 14.1114 21.1909C10.1394 26.658 8.00005 33.2421 8 39.9998C7.99995 46.7574 10.1392 53.3416 14.1112 58.8087C18.0831 64.2758 23.6839 68.3452 30.1107 70.4336C36.5376 72.522 43.4606 72.5221 49.8876 70.4341C56.3145 68.3461 61.9155 64.2771 65.8878 58.8102C69.8601 53.3433 71.9997 46.7592 72 40.0016C72.0001 37.7924 73.7911 36.0017 76.0002 36.0018C78.2093 36.0019 80.0001 37.7928 80 40.002C79.9996 48.449 77.3251 56.6791 72.3597 63.5127C67.3944 70.3463 60.3932 75.4326 52.3595 78.0427C44.3257 80.6527 35.672 80.6524 27.6384 78.042C19.6048 75.4315 12.6039 70.3448 7.63895 63.5109C2.674 56.677 -6.10341e-05 48.4468 1.04482e-09 39.9997C6.10362e-05 31.5527 2.67425 23.3224 7.63929 16.4886C12.6043 9.65481 19.6054 4.56822 27.639 1.95786C35.6726 -0.652504 44.3263 -0.652621 52.36 1.95752C54.461 2.64014 55.6109 4.89674 54.9282 6.99777C54.2456 9.09879 51.989 10.2486 49.888 9.56601Z"
      fill="url(#paint0_linear_7209_6812)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7209_6812"
        x1="80"
        y1="75.7672"
        x2="0.808591"
        y2="89.7314"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0384063" stopColor="#FFD63D" />
        <stop offset="0.141961" stopColor="#96F5B6" />
        <stop offset="0.350668" stopColor="#228BE6" />
      </linearGradient>
    </defs>
  </svg>
);

export default Spinner;
